import { gql } from "@apollo/client";

export const FETCH_TAG_LIST_QUERY = gql`
  query FETCH_TAG_LIST($start: Int!, $rows: Int!) {
    authoring_getTagsList(pagination: { start: $start, rows: $rows }, sort: DESC)
  }
`;

export const FETCH_TOPIC_LIST = gql`
  query fetchTopics {
    authoring_fetchTopics(type: "topics")
  }
`;
